import styled from "styled-components";

export const Header = styled.div`
  h1 {
    font-size: 28px;
    color: rgb(55, 81, 126);
    font-weight: 500;
  }
  p {
    font-size: 14px;
    color: rgb(117, 117, 117);
    font-weight: 300;
    margin-top: 12px;
    margin-bottom: 25px;
    line-height: 1.5;
  }
`;
